import { render } from "./index.vue?vue&type=template&id=f23d5dda"
const script = {}

import exportComponent from "D:\\01_Dev\\Projects\\active\\YouYouXiChe\\smart-car-wash-background\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__